import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInvestmentTransactions,
  addInvestmentTransaction,
  updateInvestmentTransaction,
  deleteInvestmentTransaction,
} from "./investmentTransactions.thunk";

const initialState = {
  transactions: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedTransaction: null,
};

const investmentTransactionsSlice = createSlice({
  name: "investmentTransactions",
  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedTransaction: (state, action) => {
      state.selectedTransaction = action.payload;
    },
    clearSelectedTransaction: (state) => {
      state.selectedTransaction = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== FETCH ===== */
      .addCase(fetchInvestmentTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvestmentTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })
      .addCase(fetchInvestmentTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== ADD ===== */
      .addCase(addInvestmentTransaction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addInvestmentTransaction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE ===== */
      .addCase(updateInvestmentTransaction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateInvestmentTransaction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== DELETE ===== */
      .addCase(deleteInvestmentTransaction.fulfilled, (state, action) => {
        state.transactions = state.transactions.filter(
          (tx) => tx.id !== action.payload.id
        );
      })
      .addCase(deleteInvestmentTransaction.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentPage,
  setSelectedTransaction,
  clearSelectedTransaction,
} = investmentTransactionsSlice.actions;

export default investmentTransactionsSlice.reducer;